<template>
  <div
    class="c-image-list-preview"
  >
    <template v-if="totalPage > 0">
      <div
        class="page-info"
      >
        <span
          class="btn-next"
          :class="[pageNumber === 1 ? 'btn-disable' : '']"
          @click="next()"
        >
          <i class="el-icon-arrow-left"></i>
        </span>
        <span class="page">{{ pageNumber }}/{{ picsCount }}</span>
        <span
          class="btn-pre"
          :class="[pageNumber === totalPage ? 'btn-disable' : '']"
          @click="pre()"
        >
          <i class="el-icon-arrow-right"></i>
        </span>
      </div>
      <div class="wrapper">
        <div
          class="scrollWrap"
          @scroll="scrollLoadMore"
        >
          <img
            v-for="(item, index) in listImg"
            class="scrollWrap-item"
            :key="index"
            :value="item | httpToHttps"
            fit="contain"
          />
        </div>
      </div>
    </template>
    <div class="unble-preview" v-else>
      <div class="unble-preview-wrap">
        <img src="../images/no_data.png" alt>
        <p>无法预览！！！</p>
        <p>当前文档不提供在线查看，请下载使用</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "c-new-image-preview",
  props: {
    listImg: {
      type: Array,
      default: () => ({}),
    },
    picsCount: {
      type: Number,
      default: 0
    },
    isAllPics: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    this.totalPage = this.listImg.length;
    if (this.listImg.length <= 0) {
      return;
    }
    let len = this.listImg.length < 3 ? this.listImg.length : 3;
    for (let i = 0; i < len; i++) {
      this.setLazyUrl(i);
    }
    document.getElementsByClassName('scrollWrap')[0].scrollTop = 0;
    if (len === 1 && !this.isAllPics) {
      this.isOver = true;
    }
  },
  watch: {
    listImg(newValue, oldValue) {
      if (newValue.length > 0) {
        this.totalPage = newValue.length;
        let len = newValue.length < 3 ? newValue.length : 3;
        for (let i = 0; i < len; i++) {
          this.setLazyUrl(i);
        }
        document.getElementsByClassName('scrollWrap')[0].scrollTop = 0;
        if (len === 1 && !this.isAllPics) {
          this.isOver = true;
        }
      }
    }
  },
  data() {
    return {
      pageNumber: 1,
      totalPage: 10,
      lazyPage: 0,
      isClick: false,
      isButtom: false,
      isOver: false
    };
  },
  methods: {
    scrollLoadMore() {
      if (this.listImg.length <= 0) {
        return;
      }
      if (this.isClick) {
        return;
      }
      let scrollTop = document.getElementsByClassName('scrollWrap')[0].scrollTop;
      if (document.getElementsByClassName('scrollWrap-item')[0]) {
        let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
        let page = Math.floor((scrollTop + 300) / imgHei);
        this.pageNumber = page + 1;
      }
      this.isToButtom();
    },
    // 手动懒加载
    setLazyUrl(i) {
      if (i >= this.listImg.length) {
        this.isOver = true;
        return;
      }
      let url = document.getElementsByClassName('scrollWrap-item')[i].getAttribute('value');
      document.getElementsByClassName('scrollWrap-item')[i].src = url;
      if (i > this.lazyPage) {
        this.lazyPage = i;
      }
    },
    /**
     * @description: 监听是否滚动到底部
     * @return {*}
     */
    isToButtom() {
      // 防抖
      if (this.isButtom) {
        return;
      }
      this.isOver = false;
      this.isButtom = true;
      this.$nextTick(() => {
        // 进入nexTick
        const scrollWrap = document.getElementsByClassName("scrollWrap")[0];   // 获取滚动条的dom
        // 获取距离顶部的距离
        const scrollTop = scrollWrap.scrollTop;
        // 获取可视区的高度
        const windowHeight = scrollWrap.clientHeight;
        // 获取滚动条的总高度
        const scrollHeight = scrollWrap.scrollHeight;
        if (scrollTop + windowHeight >= scrollHeight - 100) {
          // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
          if (this.listImg.length > this.lazyPage) {
            this.setLazyUrl(this.lazyPage + 1);
          }
          else {
            this.isOver = true;
          }
        }
        this.isButtom = false;
      })
    },
    next: function () {
      this.isClick = true;

      if (this.pageNumber <= 1) {
        this.pageNumber = 1;
      }
      else {
        this.pageNumber--;
      }

      let scrollWrap = document.getElementsByClassName('scrollWrap')[0];
      let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
      let page = this.pageNumber - 1;
      scrollWrap.scrollTo(0, imgHei * page);
      this.isClick = false;
    },
    pre: function () {
      this.isClick = true;

      if (this.pageNumber >= this.totalPage) {
        this.pageNumber = this.totalPage;
      }
      else {
        this.pageNumber++;
      }

      let scrollWrap = document.getElementsByClassName('scrollWrap')[0];
      let imgHei = document.getElementsByClassName('scrollWrap-item')[0].height;
      let page = this.pageNumber - 1;
      scrollWrap.scrollTo(0, imgHei * page);

      if (this.pageNumber >= this.lazyPage - 1 && this.lazyPage < this.listImg.length - 1) {
        this.setLazyUrl(this.lazyPage + 1);
      }
      this.isClick = false;
    },
  }
};
</script>
<style lang="scss" scoped>
.c-image-list-preview {
  width: 100%;
  padding: 0 12px 31px 12px;
  box-sizing: border-box;
  position: relative;

  .wrapper {
    position: relative;
    padding: 70px 38px 0 38px;
    min-height: 500px;
    background-color: #fff;
    box-sizing: border-box;
    border-bottom:  1px solid  #E7E7E7;

    .scrollWrap {
      height: 700px;
      overflow-y: auto;
       /* 隐藏滚动条 */
      scrollbar-width: none; /* firefox */
      -ms-overflow-style: none; /* IE 10+ */

      img.scrollWrap-item {
        border: 1px solid #ddd;
      }
    }

    .scrollWrap::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }

    img {
      display: block;
      width: 100%;
    }
  }

  .over-notice {
    position: absolute;
    left: 50%;
    margin-left: -112px;
    width: 224px;
    z-index: 1;

    p.over-notice-text {
      width: 224px;
      height: 19px;
      font-size: 14px;
      color: #909399;
      line-height: 19px;
      background: #fff;
      text-align: center;
      margin-top: -10px;
    }
  }

  .page-info {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1;
    user-select: none;
    background-color: #fff;
    width: 100%;
    height: 54px;
    border-radius: 4px 4px 0px 0px;
    line-height: 54px;
    text-align: center;
    box-sizing: border-box;
    border-bottom:  1px solid #E7E7E7;
    font-size: 16px;
    color: #606266;
    overflow: hidden;

    .btn-next {
      border: 0;
      min-width: 0px;
    }

    .page {
      margin: 0 10px;
    }

    i {
      cursor: pointer;

      &:hover {
        color: #000 !important;
      }
    }

    .btn-disable {
      i {
        cursor: default;
        color: #ccc !important;

        &:hover {
          color: #ccc !important;
        }
      }
    }
  }

  .unble-preview {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 600px;
    border: 1px solid rgba(204, 204, 204, 1);
    background: rgba(255, 255, 255, 1);
  }

  .unble-preview-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    text-align: center;

    p {
      line-height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/previewV2/components/CNewImagePreview.vue